<template>
  <div class="main-center">
    <div class="container container-shurt">
      <div class="card-main">
        <div class="header mb-4">
          <div class="logo mb-2">
            <Logo
              :src="summary.account_id.logo_media_url"
              max-width="160px" />
          </div>
          <h2 class="text-success">Finalizado com sucesso!</h2>
        </div>

        <p>As respostas foram enviadas para os analistas responsáveis.<br>
        Aguarde os próximos passos.<br>
        Obrigado!</p>
      </div>
      <div class="footer">by <span class="text-muted">Quickin.io</span></div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import Logo from '../components/Logo'

export default {
  name: 'finish',
  components: {
    Logo
  },
  computed: {
    summary () {
      return this.$store.getters.getSummary
    },
    isTest () {
      return this.summary ? this.summary.type === 'test' : null
    }
  }
}
</script>
